export const environment = {
  production: true,
  apiUrl: '/_api/api',
  defaultLanguage: 'lv'
};
